<template>
  <div>
    <div class="mb-1">
      <span class="font-weight-bold h6">{{ typeVariables.title }}</span>
      <a class="d-inline ml-1 link" href="#" @click.prevent="addNew">
        <i class="fa fa-plus fa-lg"></i>
      </a>
    </div>
    <div :key="role.id" class="mb-1" v-for="role in roles">
      <div v-if="!isEditing(role)" class="show-icon-on-hover">
        &nbsp;
        <strong>{{ role.title }}</strong>
        at
        <a :href="'/accounts/view/' + role.account.id">{{role.account.name}}</a>
        <a href="#">
          <i class="fa fa-lg fa-edit to-show ml-1" @click.prevent="edit(role)"></i>
        </a>
        <a href="#">
          <i
            v-if="!typeVariables.showUntilField"
            title="Move to Past Roles"
            class="fa fa-lg fa-arrow-down to-show ml-1"
            @click.prevent="$emit('move', role)"
          ></i>
        </a>
        <br />
        <span v-if="!typeVariables.showUntilField && !!role.since">
          &nbsp;&nbsp;
          Since
          {{ role.since }}
        </span>
        <span
          v-if="typeVariables.showUntilField && (role.since || role.until)"
        >&nbsp;&nbsp;&nbsp;{{ role.since ? role.since : "Unknown" }} &ndash; {{ role.until ? role.until : "Unknown" }}</span>
      </div>
      <form @submit.prevent="saveForm" action="#">
        <div class="my-4" v-if="isEditing(role)">
          <div class="input-group mb-2">
            <input
              class="form-control"
              type="text"
              v-model="formData.title"
              placeholder="Title..."
              required
            />
            <div class="input-group-append">
              <input class="btn btn-outline-primary" type="submit" value="Save" />
              <a
                href="#"
                class="btn btn-outline-secondary"
                @click.prevent="cancelEdit(role)"
              >Cancel</a>
            </div>
          </div>
          <select v-model="formData.accountId" class="form-control mb-2" id="sel1" required>
            <option disabled value>Select account...</option>
            <option :key="account.id" v-for="account in accounts" :value="account.id">{{account.name}}</option>
          </select>
          <div v-if="!typeVariables.showUntilField" class="form-inline">
            <label>Since:</label>
            <input v-model="formData.since" type="date" class="small-date form-control ml-1" />
          </div>
          <div v-if="typeVariables.showUntilField" class="form-inline">
            <input v-model="formData.since" type="date" class="small-date form-control mr-1" /> &ndash;
            <input v-model="formData.until" type="date" class="small-date form-control ml-1" required/>
          </div>
        </div>
      </form>
    </div>
    <p v-if="roleList.length < 1" class="font-italic text-muted mb-1">&nbsp; No {{ typeVariables.empty }}</p>
  </div>
</template>

<script>
import Vue from "vue";

const types = {
   current: {
     title: 'Current Roles',
     showUntilField: false,
   },
   past: {
     title: 'Past Roles',
     showUntilField: true,
   },
}

export default {
  props: ["roleList", "type", "accounts"],

  data() {
    return {
      formData: null,
    };
  },

  computed: {
    roles() {
      let roles = this.roleList;
      if (this.formData && this.formData.id === "new") {
        roles.push(this.formData);
      }
      return roles;
    },
    isEditing() {
      return role => {
        return this.formData && this.formData.id === role.id;
      };
    },
    typeVariables() {
      let vars = types[this.type];
      vars.empty = vars.title.slice(0, 1).toLowerCase() + vars.title.slice(1);
      return vars;
    }
  },

  methods: {
    edit(role) {
      this.formData = Object.assign({}, role, {accountId: role.account.id, type: this.type});
    },
    cancelEdit(role) {
      this.formData = null;
    },
    saveForm() {
      this.$emit('save', this.formData);
    },
    addNew() {
      this.formData = {
        id: 'new',
        title: '',
        since: null,
        until: null,
        accountId: '',
        type: this.type,
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// assets/js/components/RoleListRow.vue